<template>
  <div>
    <label
      v-if="$slots.label || label"
      class="text-default text-left block w-full pl-2 mb-2 mt-2 font-normal"
    >
      <slot name="label">
        {{ label }}
      </slot>
      <font-awesome-icon
        v-if="tooltip"
        v-tooltip.top="tooltip"
        class="text-black text-default font-normal"
        :icon="['fal', 'question-circle']"
      />
    </label>
    <input
      :value="value"
      :type="type"
      v-bind="$attrs"
      class="w-full py-1 h-8 px-2 bg-gray-200 rounded text-gray-700 tracking-wider placeholder-neutral-700 disabled:opacity-75 disabled:cursor-not-allowed"
      :disabled="isDisabled"
      :placeholder="placeholder"
      @input="input"
      v-on="listeners"
    >
    <div
      v-if="isOptional"
      class="text-default text-neutral-700 text-right"
    >
      ({{ $t('GLOBAL.OPTIONAL', 'optional') }})
    </div>
    <span
      v-if="$slots.errorMessage || errorMessage"
      class="text-default text-red-500"
    >
      <slot name="errorMessage">
        {{ errorMessage }}
      </slot>
    </span>
  </div>
</template>

<script>
import { library } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { faQuestionCircle } from '@fortawesome/pro-light-svg-icons'
library.add(faQuestionCircle)
export default {
  name: 'ZInput',
  components: {
    'font-awesome-icon': FontAwesomeIcon
  },
  props: {
    label: { type: String, default: null },
    errorMessage: { type: String, default: null },
    isOptional: { type: Boolean, default: false },
    isDisabled: { type: Boolean, default: false },
    type: { type: String, default: 'text' },
    value: { default: null },
    placeholder: { type: String, default: null },
    tooltip: { type: String, default: null }
  },
  computed: {
    listeners () {
      // eslint-disable-next-line no-unused-vars
      const { input, ...listeners } = this.$listeners
      return listeners
    }
  },
  methods: {
    input (event) {
      this.$emit('input', event.target.value)
    }
  }
}
</script>
